import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthService } from "../services/authService/auth.service";

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}
  canActivate(): boolean {
    const token = localStorage.getItem('accessToken')
    if (token) {
      this.router.navigate(['/admin/dashboard']);
      return false;
    }
    return true; 
  }
}